import PropTypes from 'prop-types';
import { Box, Stack, Typography } from '@mui/material';

const styles = {
  titleWrapper: ({ palette }) => ({
    height: 80,
    paddingLeft: 10,
    backgroundColor: palette.colors.lightPale,
  }),
  contentWrapper: {
    padding: 6,
  },
};

export const JournalSection = ({ title, children = null }) => {
  return (
    <>
      <Stack direction="row" alignItems="center" sx={styles.titleWrapper}>
        <Typography variant="subtitle1-bold" component="h4">
          {title}
        </Typography>
      </Stack>
      <Box sx={styles.contentWrapper}>{children}</Box>
    </>
  );
};

JournalSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
};
